import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { useNavigate } from 'react-router-dom';
import { useUpdateChapterMutation } from 'App/services/chapterServiceApi';
import { useGetBySubCategoryIdQuery } from 'App/services/chapterServiceApi';
import { useGetAllSubCategoryQuery } from 'App/services/subCategoryServiceApi';
import { Icon, IconButton } from '@mui/material';
import { toast } from 'react-toastify';



export default function EditChapterFormDialogue({ chapter }) {
    
    const [open, setOpen] = React.useState(false);
    const [chapterName, setChapterName] = React.useState(chapter.name);
    const [categoryId, setCategoryId] = React.useState(chapter.cat_id);
    const [subcategoryId, setSubCategoryId] = React.useState(chapter.subCat_id);
    const [error, setError] = React.useState('');;
    const navigate = useNavigate();

    const { data: chapters, error: chaptersError, isLoading: chaptersLoading } = useGetAllSubCategoryQuery();
    const [updateChapter, { isLoading, isError }] = useUpdateChapterMutation();

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleEditChapter = async (event) => {
        event.preventDefault();

        if(chapterName){
        try {
            await updateChapter({ id: chapter.id, name: chapterName, subcategoryId, categoryId});
            toast.success("Sub Category Successfully updated!");
            // navigate('/subcategory');
            handleClose();
        } catch (err) {
            toast.error("Something went wrong!!")
        }
    }
    else{
        toast.error("Required to chapter name Field");
    }
    };

    return (
        <React.Fragment>
            <IconButton  onClick={handleClickOpen}>
                <Icon>edit</Icon>
            </IconButton>
            <Dialog
                open={open}
                onClose={handleClose}
                PaperProps={{
                    component: 'form',
                    onSubmit: handleEditChapter,
                }}
            >
                <DialogTitle>Edit Chapter Name</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Update the name and category of the subcategory:
                    </DialogContentText>
                    <TextField
                        autoFocus
                        // required
                        margin="dense"
                        id="name"
                        name="name"
                        label="Chapter Name"
                        type="text"
                        fullWidth
                        value={chapterName}
                        onChange={(e) => setChapterName(e.target.value)}
                        error={!!error}
                        helperText={error}
                    />
                    <Select
                        required
                        fullWidth
                        sx={{  height: 40 }}
                        value={subcategoryId}
                        onChange={(e) => setSubCategoryId(e.target.value)}
                        displayEmpty
                        disabled
                    >
                        <p style={{color:"red"}}>{error}</p>
                        <MenuItem value="" disabled>Select Sub Category</MenuItem>
                        {chaptersLoading ? (
                            <MenuItem disabled>Loading...</MenuItem>
                        ) : chaptersError ? (
                            <MenuItem disabled>Error loading sub categories</MenuItem>
                        ) : (
                            chapters.map((chapter) => (
                                <MenuItem key={chapter.id} value={chapter.id}>
                                    {chapter.name}
                                </MenuItem>
                            ))
                        )}
                    </Select>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button type="submit" disabled={isLoading} name="submit">
                        Update {isLoading && 'Loading...'}
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
